import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Wrapper from "./sidebarLeftDesktop.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useSpring, animated } from "@react-spring/web";
import FairGoLogo from "../../theme/assets/fairgo-logo.svg";
import NimbleLogo from "../../theme/assets/nimble-logo.svg";
import { UnStyledLink } from "../textButton";
import { PRIVATE_ROUTE } from "../../route.constants";
import Footer from "../footer/footer";
import SidebarContent from "./sidebarContent";
import { useTheme } from 'styled-components';
import { brands } from "@theme/config";
import environmentSettings from "@constants/environmentSettings";

const SidebarLeftDesktop = () => {
  const themeName = useSelector((state) => state.StartUp.brand.themeName);

  const { companyName } = environmentSettings;

  const getSessionStorageValue =
    sessionStorage.getItem("expandedStatusLeft") === "false" ? false : true;
  const [isExpandedLeftNav, setIsExpandedLeftNav] = useState(
    getSessionStorageValue
  );

  const theme = useTheme();

  const isNimbleTheme = themeName === brands.nimbleBrand.themeName;
  const collapsedNavWidth = isNimbleTheme ? 50 : 40;

  const [springs, api] = useSpring(() => ({
    from: { width: isExpandedLeftNav ? 340 : 60 },
  }));

  const [springsLogo, apiLogo] = useSpring(() => ({
    from: {
      width: isExpandedLeftNav ? 180 : collapsedNavWidth,
      height: isExpandedLeftNav ? 120 : collapsedNavWidth,
    },
  }));

  const [springsFooter, apiFooter] = useSpring(() => ({
    from: {
      transform: isExpandedLeftNav ? "translateX(0px)" : "translateX(-250px)",
    },
  }));

  const handleExpandLeftNav = useCallback(() => {
    sessionStorage.setItem("expandedStatusLeft", "true");
    setIsExpandedLeftNav(true);
    api.start({
      from: {
        width: 60,
      },
      to: {
        width: 340,
      },
    });
    apiLogo.start({
      from: {
        width: collapsedNavWidth,
        height: 40,
      },
      to: {
        width: 180,
        height: 120,
      },
    });
    apiFooter.start({
      from: {
        transform: "translateX(-250px)",
      },
      to: {
        transform: "translateX(0px)",
      },
    });
  }, [setIsExpandedLeftNav, apiFooter, apiLogo, api, collapsedNavWidth]);

  const handleCollapseLeftNav = useCallback(() => {
    sessionStorage.setItem("expandedStatusLeft", "false");
    setIsExpandedLeftNav(false);
    api.start({
      from: {
        width: 340,
      },
      to: {
        width: 60,
      },
    });
    apiLogo.start({
      from: {
        width: 180,
        height: 120,
      },
      to: {
        width: collapsedNavWidth,
        height: 40,
      },
    });
    apiFooter.start({
      from: {
        transform: "translateX(0px)",
      },
      to: {
        transform: "translateX(-250px)",
      },
    });
  }, [setIsExpandedLeftNav, apiFooter, apiLogo, api, collapsedNavWidth]);

  useEffect(() => {
    if (sessionStorage.getItem("expandedStatusLeft") === null) {
      sessionStorage.setItem("expandedStatusLeft", "true");
    } else {
      return;
    }
  });

  let logo = FairGoLogo;
  if (themeName === brands.nimbleBrand.themeName) {
    logo = NimbleLogo;
  }

  return (
    <animated.div
      className="nav-left-desktop"
      style={{
        background: theme.palette.header.background,
        ...springs,
      }}
    >
      <Wrapper isExpandedLeftNav={isExpandedLeftNav}>
        <div className="sidebar">
          <button
            className="left-nav-expand"
            onClick={
              isExpandedLeftNav ? handleCollapseLeftNav : handleExpandLeftNav
            }
          >
            <FontAwesomeIcon icon={faBars} color={theme.palette.header.active} size="lg" />
          </button>
          <UnStyledLink
            to={PRIVATE_ROUTE.LANDING}
            className="mid-container-desktop"
          >
            <animated.div
              className="fgf-logo-animate"
              style={{
                ...springsLogo,
              }}
            >
              <img src={logo} alt={`${companyName} Desktop`} />
            </animated.div>
          </UnStyledLink>
          <SidebarContent
            isExpandedLeftNav={isExpandedLeftNav}
            shouldShowSidebarContent={true}
            menuSide="left"
          />
          <animated.div style={{ ...springsFooter }} className="footer-group">
            <Footer />
          </animated.div>
        </div>
      </Wrapper>
    </animated.div>
  );
};

export default SidebarLeftDesktop;
